export default __webpack_public_path__ + "static/media/table-work.a3592164.svg";